export const letterSpacings = {
  0: '0px',
  0.25: '.25px',
  6: '6px',
  8: '8px',
};
